import React from "react";

const LOGO = "https://secure-pdf-sales.preview.emergentagent.com/MBSH-logo.jpeg";

const PinFrame = ({ children, bg, id }) => (
  <div
    data-testid={`pin-${id}`}
    style={{
      width: "1000px",
      height: "1500px",
      backgroundColor: bg,
      position: "relative",
      overflow: "hidden",
      fontFamily: "'Outfit', sans-serif",
      flexShrink: 0,
    }}
  >
    {children}
  </div>
);

const OrnamentalRule = ({ color = "#d4af6a", hairlineColor = "rgba(212, 175, 106, 0.45)" }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "20px", margin: "30px 0" }}>
    <span style={{ display: "block", height: "1px", width: "90px", backgroundColor: hairlineColor }} />
    <span style={{ fontSize: "22px", color }}>✦</span>
    <span style={{ display: "block", height: "1px", width: "90px", backgroundColor: hairlineColor }} />
  </div>
);

const Footer = ({ wordmarkColor = "#042F2E", urlColor = "#068fa2", logoBg = "transparent" }) => (
  <div style={{ position: "absolute", bottom: "60px", left: 0, right: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
    <img src={LOGO} alt="Mind Body Spirit HYGIENE Tools" style={{ width: "80px", height: "80px", borderRadius: "50%", objectFit: "cover", backgroundColor: logoBg }} />
    <div style={{ textAlign: "center" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "22px", fontStyle: "italic", fontWeight: 500, margin: 0, color: wordmarkColor }}>
        Mind Body Spirit HYGIENE<sup style={{ fontSize: "12px" }}>™</sup> Tools
      </p>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.35em", margin: "10px 0 0 0", color: urlColor, fontWeight: 500 }}>
        mindbodyspirithygienetools.com
      </p>
    </div>
  </div>
);

const Pin1 = () => (
  <PinFrame bg="#efeae7" id="1">
    <div style={{ position: "absolute", top: "120px", left: 0, right: 0, textAlign: "center" }}>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "14px", textTransform: "uppercase", letterSpacing: "0.4em", color: "#068fa2", fontWeight: 500, margin: 0 }}>
        For the woman in the messy middle
      </p>
      <OrnamentalRule />
    </div>
    <div style={{ position: "absolute", top: "300px", left: "80px", right: "80px", textAlign: "center" }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "92px", fontWeight: 500, lineHeight: "1.05", color: "#042F2E", margin: 0, letterSpacing: "-0.01em" }}>
        This is for the woman who keeps <em style={{ color: "#25a1c2" }}>saying yes</em>.
      </h1>
    </div>
    <div style={{ position: "absolute", top: "880px", left: "120px", right: "120px", textAlign: "center" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "34px", fontStyle: "italic", color: "#068fa2", lineHeight: "1.4", margin: 0 }}>
        You GET TO say no. <br />When you're ready.
      </p>
    </div>
    <Footer />
  </PinFrame>
);

const Pin2 = () => (
  <PinFrame bg="#042F2E" id="2">
    <div style={{ position: "absolute", top: "140px", left: 0, right: 0, textAlign: "center" }}>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "14px", textTransform: "uppercase", letterSpacing: "0.45em", color: "#d4af6a", fontWeight: 500, margin: 0 }}>
        The generational curse breaker
      </p>
      <OrnamentalRule color="#d4af6a" hairlineColor="rgba(212, 175, 106, 0.5)" />
    </div>
    <div style={{ position: "absolute", top: "470px", left: "60px", right: "60px", textAlign: "center" }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "150px", fontWeight: 500, fontStyle: "italic", lineHeight: "1.0", color: "#efeae7", margin: 0, letterSpacing: "-0.015em" }}>
        The buck<br />stops here.
      </h1>
    </div>
    <div style={{ position: "absolute", top: "1000px", left: "120px", right: "120px", textAlign: "center" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "30px", fontStyle: "italic", color: "rgba(239, 234, 231, 0.75)", lineHeight: "1.5", margin: 0 }}>
        For every woman who picks up this work,<br />an entire family system shifts.
      </p>
    </div>
    <Footer wordmarkColor="#efeae7" urlColor="#d4af6a" logoBg="#efeae7" />
  </PinFrame>
);

const Pin3 = () => (
  <PinFrame bg="#efeae7" id="3">
    <div style={{ position: "absolute", top: "140px", left: 0, right: 0, textAlign: "center" }}>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "14px", textTransform: "uppercase", letterSpacing: "0.45em", color: "#068fa2", fontWeight: 500, margin: 0 }}>
        The kitchen-table reframe
      </p>
      <OrnamentalRule />
    </div>
    <div style={{ position: "absolute", top: "380px", left: 0, right: 0, textAlign: "center" }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "200px", fontWeight: 600, lineHeight: "1.0", color: "#042F2E", margin: 0, letterSpacing: "0.01em" }}>
        I GET TO.
      </h1>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "46px", fontStyle: "italic", color: "#25a1c2", margin: "40px 0 0 0", lineHeight: "1.3" }}>
        Because I'm alive and able.
      </p>
    </div>
    <div style={{ position: "absolute", top: "960px", left: "120px", right: "120px", textAlign: "center" }}>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "20px", color: "#068fa2", lineHeight: "1.7", margin: 0, fontWeight: 400 }}>
        Not toxic positivity. Just reclaiming agency.<br />Daily. Non-negotiable. Yours.
      </p>
    </div>
    <Footer />
  </PinFrame>
);

const Pin4 = () => (
  <PinFrame bg="#efeae7" id="4">
    <div style={{ position: "absolute", top: "130px", left: 0, right: 0, textAlign: "center" }}>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "14px", textTransform: "uppercase", letterSpacing: "0.45em", color: "#068fa2", fontWeight: 500, margin: 0 }}>
        Real tools for real boundaries
      </p>
      <OrnamentalRule />
    </div>
    <div style={{ position: "absolute", top: "400px", left: "80px", right: "80px", textAlign: "center" }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "130px", fontWeight: 500, lineHeight: "1.0", color: "#042F2E", margin: 0, letterSpacing: "-0.01em" }}>
        My no is no.
      </h1>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "64px", fontStyle: "italic", color: "#25a1c2", margin: "40px 0 0 0", lineHeight: "1.1" }}>
        It is not a negotiation.
      </p>
    </div>
    <div style={{ position: "absolute", top: "990px", left: "120px", right: "120px", textAlign: "center" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "30px", fontStyle: "italic", color: "#068fa2", lineHeight: "1.5", margin: 0 }}>
        The explanation is for me.<br />Not them.
      </p>
    </div>
    <Footer />
  </PinFrame>
);

const Pin5_StopAbandoning = () => (
  <PinFrame bg="#042F2E" id="5">
    <div style={{ position: "absolute", top: "140px", left: 0, right: 0, textAlign: "center" }}>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "14px", textTransform: "uppercase", letterSpacing: "0.45em", color: "#d4af6a", fontWeight: 500, margin: 0 }}>
        People-pleaser syndrome
      </p>
      <OrnamentalRule color="#d4af6a" hairlineColor="rgba(212, 175, 106, 0.5)" />
    </div>
    <div style={{ position: "absolute", top: "440px", left: "60px", right: "60px", textAlign: "center" }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "130px", fontWeight: 500, fontStyle: "italic", lineHeight: "1.0", color: "#efeae7", margin: 0, letterSpacing: "-0.015em" }}>
        Stop<br />abandoning<br />yourself.
      </h1>
    </div>
    <div style={{ position: "absolute", top: "1020px", left: "100px", right: "100px", textAlign: "center" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "30px", fontStyle: "italic", color: "rgba(239, 234, 231, 0.78)", lineHeight: "1.5", margin: 0 }}>
        People-pleasing is self-abandonment<br />in a softer voice.
      </p>
    </div>
    <Footer wordmarkColor="#efeae7" urlColor="#d4af6a" logoBg="#efeae7" />
  </PinFrame>
);

const Pin6_CutTry = () => (
  <PinFrame bg="#efeae7" id="6">
    <div style={{ position: "absolute", top: "130px", left: 0, right: 0, textAlign: "center" }}>
      <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "14px", textTransform: "uppercase", letterSpacing: "0.45em", color: "#068fa2", fontWeight: 500, margin: 0 }}>
        The word that leaks your power
      </p>
      <OrnamentalRule />
    </div>
    <div style={{ position: "absolute", top: "370px", left: "80px", right: "80px", textAlign: "center" }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "115px", fontWeight: 500, lineHeight: "1.0", color: "#042F2E", margin: 0, letterSpacing: "-0.01em" }}>
        Cut the word
      </h1>
      <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "210px", fontWeight: 700, fontStyle: "italic", lineHeight: "1.0", color: "#25a1c2", margin: "20px 0 0 0", letterSpacing: "0.02em" }}>
        TRY
      </h1>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "60px", color: "#042F2E", margin: "30px 0 0 0", lineHeight: "1.0" }}>
        from your vocabulary.
      </p>
    </div>
    <div style={{ position: "absolute", top: "1020px", left: "100px", right: "100px", textAlign: "center" }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "28px", fontStyle: "italic", color: "#068fa2", lineHeight: "1.5", margin: 0 }}>
        Yes is yes. No is no.<br />"I'll try" leaks your power.
      </p>
    </div>
    <Footer />
  </PinFrame>
);

const PinterestTemplates = () => {
  return (
    <div data-testid="pinterest-templates-page" style={{ minHeight: "100vh", backgroundColor: "#1a1a1a", padding: "40px 20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "40px" }}>
      <div style={{ color: "#efeae7", textAlign: "center", maxWidth: "1000px" }}>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "42px", margin: "0 0 10px 0" }}>
          Pinterest Pin Templates — V2 (Brand-Locked)
        </h1>
        <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: "16px", color: "rgba(255,255,255,0.7)" }}>
          1000 × 1500 px · 2:3 Pinterest standard · Locked palette + fonts + voice
        </p>
      </div>

      <Pin1 />
      <Pin2 />
      <Pin3 />
      <Pin4 />
      <Pin5_StopAbandoning />
      <Pin6_CutTry />
    </div>
  );
};

export default PinterestTemplates;
